<template>
  <div class="mb-10">
    <h4>Semnatura</h4>
    <div class="wrapper">
      <canvas
        id="signature-pad"
        class="signature-pad"
        width="400"
        height="200"
      ></canvas>
    </div>
    <v-btn @click="undo" color="primary">Reseteaza</v-btn>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  name: 'SignaturePad',
  data: () => ({
    signaturePad: null,
  }),
  mounted() {
    this.signaturePad = new SignaturePad(
      document.getElementById('signature-pad'),
      {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 0)',
      }
    );
  },
  methods: {
    undo() {
      this.signaturePad.clear();
    },
    getSignature() {
      return this.signaturePad.isEmpty()
        ? null
        : this.signaturePad.toDataURL('image/jpeg');
    },
    setSignature(signatureData) {
      this.signaturePad.fromDataURL(signatureData, {
        ratio: 1,
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
  width: 400px;
  height: 200px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.signature-pad {
  position: absolute;
  left: 0;
  top: 0;
  width: 400px;
  height: 200px;
  border: 2px solid black;
}
</style>
